import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'
import settings from '../settings'

const initialState = {
    isLoggedIn: false,
    userdata: '',
    token: Cookies.get(settings.authTokenCookieName)
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUserdata: (state, action) => {
            state.userdata = action.payload
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
        login: (state) => {
            state.isLoggedIn = true
            Cookies.set(settings.authTokenCookieName, state.token)
        },
        logout: (state) => {
            state.token = ''
            state.isLoggedIn = false
            state.userdata = ''
            Cookies.remove(settings.authTokenCookieName)
        },

    },
})

export const { setUserdata, setToken, login, logout } = authSlice.actions

export default authSlice.reducer